import { inject, Injectable } from '@angular/core';
import {
  CrmLayoutProfileConfig,
  CrmLayoutProfileProvider,
  CrmLayoutSiderControl,
} from 'common-module/layout-v2';
import { CrmUserProfileItem } from 'common-module/user-profile';
import { ProfileKey } from '@app/core/crm/configuration/layout.config';
import { CommonModalsService } from '@app/core/services/common-modals.service';
import { AppRoutes } from '@app/app.routes';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutProfileProvider extends CrmLayoutProfileProvider {
  private commonModal = inject(CommonModalsService);

  override getComponentConfig(): Observable<CrmLayoutProfileConfig> {
    return super.getComponentConfig().pipe(
      map((config) => {
        return {
          ...config,
          dropdownTrigger: 'click',
        };
      }),
    );
  }

  override handleItemClicked({
    item,
  }: {
    event: MouseEvent;
    item: CrmUserProfileItem;
    siderControl?: CrmLayoutSiderControl;
  }) {
    switch (item.key) {
      case ProfileKey.logout:
        this.userService.logout().subscribe(() => {
          this.router.navigateByUrl('/auth/login');
        });
        break;
      case ProfileKey.support:
        this.commonModal.supportModal();
        break;
      case ProfileKey.history:
        this.router.navigate([AppRoutes.changelog]);
        break;
      case ProfileKey.spec:
        window.open(`assets/static/docs/technical-documentation.html`);
        break;
      case ProfileKey.userManual:
        window.open(`assets/static/docs/user-manual.html`);
        break;
      default:
        break;
    }
  }
}
